import type { TrackableUserAction } from "@js/middlewares/analytics/types";
import { Events } from "@js/services/analytics";
import { logEvent } from "@js/services/analytics/event-logging";

export const handleOnboardingAnalyticsActions = (
  action: TrackableUserAction,
) => {
  switch (action.type) {
    case Events.CHOOSE_PERSONAL_ACCOUNT: {
      logEvent(Events.CHOOSE_PERSONAL_ACCOUNT);
      break;
    }

    default: {
      break;
    }
  }
};
